// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__lNyTr","productName":"Table_productName__1jxUx"};